/**
 * TRUST_LEVELS defines the enum of possible trust levels for communication targets.
 */
export const TRUST_LEVELS = {
  UNTRUSTED: 'untrusted',
  TRUSTED: 'trusted',
} as const;

/**
 * The TrustLevel type represents the trust level of a communication target.
 * It can be either 'trusted' or 'untrusted', as defined in TRUST_LEVELS.
 */
export type TrustLevel = (typeof TRUST_LEVELS)[keyof typeof TRUST_LEVELS];

/**
 * A list of untrusted hostnames (subdomains of these hostnames are also
 * untrusted) that are not allowed to be trusted by default.
 * Maintaining this separate list as a forcing function to ensure that
 * hostnames we don't want to trust are not trusted without careful
 * consideration.
 */
export const UNTRUSTED_HOSTNAMES = [
  /**
   * stripecdn.com is used for hosting third party assets which we generally
   * don't trust (which is why we have stripecdn.com in the first place).
   * Even though we manage the content on stripecdn.com, we don't trust it since
   * we relax a bunch of our security policies there and can't guarantee that
   * the content is safe.
   */
  'stripecdn.com',
];

/**
 * A list of trusted hostnames (subdomains of these hostnames are also allowed/trusted)
 * that are allowed to be trusted by default.
 */
export const TRUSTED_HOSTNAMES = [
  'stripe.com',
  /**
   * normally stripe.me would not be trusted since it hosts development assets, but it should be fine in
   * the context of cross frame communication as it hosts first party content. There is still a risk
   * that the content is not safe, but I think the tradeoff for usability is worth it.
   */
  'stripe.me',
];
